import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import {Tabs, Tab} from 'material-ui/Tabs';
import ACLList from './ACLList';
import APIKeys from './APIKeys';
import mutations from '../../graphql/mutations';
import Dialog from '../overlay/Dialog';
import OverlayController from '../overlay/OverlayController';
import { compose } from 'react-apollo';
import './ProjectSettingsDialog.css'


class ProjectSettingsDialog extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            apiSecretKey: props.project.apiSecretKey
        };
    }

    didClickDeleteButton() {
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
            {label: 'Delete', handler: this.didClickDeleteApproveButton.bind(this)}
        ];
        OverlayController.showOverlay({
            component: <Dialog title={`Are you sure you want to delete ${this.props.project.name} project`} actions={actions} />
        });
    }

    didClickDeleteApproveButton() {
        OverlayController.hideOverlay();
        OverlayController.showActivityIndicator();
        this.props.deleteProject(this.props.project.id)
            .then(({data}) => {
                console.log('got data', data);
                OverlayController.hideActivityIndicator();
                OverlayController.hideOverlay();
            })
            .catch((error) => {
                console.log('there was an error sending the query', error);
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    render() {
        let actions = [{label: 'Done', handler: () => OverlayController.hideOverlay()}];
        let isCurrentUserAdmin = (this.props.project.aclRole === "admin");
        return (
            <Dialog showTitleBar={true} title={`Project Settings`} actions={actions} className="project-settings-dialog">
                {!isCurrentUserAdmin ?
                    <APIKeys project={this.props.project}/> : (
                    <Tabs inkBarStyle={{height: 4, marginTop: -4}} contentContainerClassName="project-settings-dialog-tabs-content-container">
                        <Tab label="API Keys">
                            <APIKeys project={this.props.project}/>
                        </Tab>
                        <Tab label="Access List">
                            <ACLList project={this.props.project} />
                        </Tab>
                        <Tab label="Danger Zone">
                            <div style={{textAlign: "center"}}>
                                <RaisedButton className="project-delete-button" label="Delete Project" secondary={true} onTouchTap={this.didClickDeleteButton.bind(this)}/>
                            </div>
                        </Tab>
                    </Tabs>
                )}
            </Dialog>
        );
    }

}


export default compose(
    mutations.deleteProjectMutationHoc
)(ProjectSettingsDialog);



// WEBPACK FOOTER //
// ./src/components/projectSettings/ProjectSettingsDialog.js